<div class="container" fxLayout="column" fxLayoutAlign="space-evenly stretch">
    <h1 mat-dialog-title>{{ 'ImagePreview' | translate }}</h1>

    <mat-dialog-content>
        <ng-container *ngIf="!previewAvailable">
            <p class="no-preview-text">{{ 'no_preview_available' | translate}}</p>

        </ng-container>

        <ng-container *ngIf="previewAvailable">
            <img [src]="imageBlobUrl" *ngIf="imageBlobUrl && isImg" class="imgPlaceholder" alt="">
        </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions class="actions">
        <button #closeBtn mat-button mat-dialog-close>{{ 'Close'|translate }}</button>
        <button mat-raised-button color="primary" (click)="download()">{{ 'Download' | translate }}</button>
    </mat-dialog-actions>
</div>
